import { render, staticRenderFns } from "./OtherSelectBoxDialog.vue?vue&type=template&id=62ac5008&scoped=true&"
import script from "./OtherSelectBoxDialog.vue?vue&type=script&lang=js&"
export * from "./OtherSelectBoxDialog.vue?vue&type=script&lang=js&"
import style0 from "./OtherSelectBoxDialog.vue?vue&type=style&index=0&id=62ac5008&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ac5008",
  null
  
)

export default component.exports